const SET_DEFAULT_AVATARS = (state, payload) => {
  state.defaultAvatars = payload;
}

export {
  SET_DEFAULT_AVATARS,
}